import './OkulSiparisDetayPage.scss'

import type { TabsProps } from 'antd'
import { Tabs } from 'antd'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useOkulSiparisSatiriDetayQuery } from '../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../spinner/Spinner'

dayjs.extend(isBetween)

const OkulSiparisSatiriDetayPage: React.FC = () => {
  const { siparisSatiriId } = useParams()
  const navigate = useNavigate()
  // API isteğini gerçekleştir
  const { data, loading, error } = useOkulSiparisSatiriDetayQuery({
    variables: { siparis_satiri_id: parseInt(siparisSatiriId!) },
    skip: !siparisSatiriId || isNaN(Number(siparisSatiriId)), // Geçersiz ID varsa isteği yapma
  })

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error('API Hatası:', error)
    navigate('/')
    return null
  }

  const orderLineDetail = data?.okulSiparisSatiriDetay?.siparis_satiri
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Sipariş Bilgileri',
      children: (
        <div className="okul-yonetim-admin-detail-tab">
          <div className="tab-container">
            <h1>Sipariş Bilgileri</h1>
            <div className="tab-content">
              <div className="tab-content-row">
                <div className="tab-content-row-label">Sipariş ID</div>
                <div className="tab-content-row-value">{orderLineDetail?.siparis_id ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Öğrenci</div>
                <div className="tab-content-row-value">{orderLineDetail?.ogrenci_ismi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Öğrenci Cinsiyet</div>
                <div className="tab-content-row-value">{orderLineDetail?.ogrenci_cinsiyet ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Öğrenci T.C No</div>
                <div className="tab-content-row-value">{orderLineDetail?.kimlik_no ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kalan Adet</div>
                <div className="tab-content-row-value">{orderLineDetail?.kalan_adet ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Sıra</div>
                <div className="tab-content-row-value">{orderLineDetail?.sira ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Durum</div>
                <div className="tab-content-row-value">{orderLineDetail?.durum_aciklama ?? '-'}</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ]

  return (
    <div className="okul-siparis-satiri-detay-page">
      <div className="okul-sepeti-admin-header">
        <h1>Okul Siparişleri Satırları</h1>
      </div>
      {/* Sipariş Detaylarını Göster */}
      <div>
        {data?.okulSiparisSatiriDetay ? (
          <Tabs defaultActiveKey="1" items={items} />
        ) : (
          <p>Sipariş bilgisi bulunamadı.</p>
        )}
      </div>
    </div>
  )
}

export default OkulSiparisSatiriDetayPage
